import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()
  //const { breakpoints } = useTheme()
  return {
    itemTitle: {
      width: 'calc(100% - 60px)',
      wordBreak: 'break-word',
      display: '-webkit-box',
      WebkitLineClamp: 2, // Número de líneas antes de cortar
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    items: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '66%',
      gap: '10px',
      justifyContent: 'space-between',
      background: `${colors.color10}22`,
      padding: '15px',
      position: 'relative',
      minHeight: '55px',
    },
    containerFileData: {
      display: 'flex',
      mt: 2,
      //justifyContent:
    },
    containerType: {
      display: 'flex',
      justifyContent: 'center',
      width: '32%',
      alignItems: 'center',
    },
    containerSecond: {
      width: '70%'
    },
    delete: {
      color: colors.color19,
      fontSize: '20px',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    upload: {
      color: colors.color4,
      fontSize: '20px',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    containerProgress: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      paddingLeft: '10px'
    },
    customPaper: {
      padding: '12px',
      minHeight: '136px'
    },
    label: {
      fontSize: '14px',
    },
    paper: (isDragActive: boolean) => ({
      mt: 1,
      p: 2,
      borderStyle: 'dashed',
      borderColor: isDragActive ? 'primary.main' : 'grey.400',
      textAlign: 'center',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 1,
      '& .MuiSvgIcon-root': {
        fontSize: '2rem',
        color: colors.color32,
      }
    }),
    cancelUpload: {
      color: colors.color19,
      fontSize: '20px',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    progress: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      minHeight: '55px',
      top: 0,
      left: '0px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backdropFilter: 'blur(5px)',
    },
    iconContainer: {
      width: '50px',
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      '& .MuiIconButton-root': {
        '&.download': {
          color: colors.color4,
          width: '25px',
          height: '25px'
        },
        '&.delete': {
          color: colors.color19,
          width: '25px',
          height: '25px'
        },
        fontSize: '1.2rem',
        padding: '2px',
        '& .MuiSvgIcon-root': {
          fontSize: '1em',
        },
      },
    },
  }
}

export { useStyles }
